import { Box, Skeleton, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import Link from 'next/link';
import Marquee from 'react-fast-marquee';
import { getLandingPageGroups } from 'src/logic/services/catalogue/classification';
import { sm } from 'src/site-map';
import PrimaryButton from '../components/buttons/PrimaryButton';

const CategoriesSlider = () => {
  const { data } = useQuery({
    queryKey: ['LANDING_PAGE_GROUPS'],
    queryFn: async () => {
      const { data } = await getLandingPageGroups();
      return data.items;
    },
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    staleTime: Infinity,
    cacheTime: Infinity,
    retry: 1,
  });

  return (
    <div style={{ paddingBlock: '4rem' }}>
      <Typography
        textAlign={'center'}
        px={1}
        fontSize={{ xs: 26, lg: 44 }}
        fontWeight={600}
        color='#070A0D'
        maxWidth={'730px'}
        mx='auto'
        lineHeight={1}
        component='h2'
      >
        Over <span style={{ color: '#005FCC' }}>800 categories</span>
        <br />
        of products and services
      </Typography>

      <div style={{ marginBlock: '2rem' }}>
        {data ? (
          <Marquee autoFill pauseOnHover style={{ overflow: 'hidden' }}>
            {data.map(group => (
              <Box key={group.id} mr={4} display={'flex'} alignItems={'center'} gap={'0.5rem'}>
                <div
                  style={{
                    width: '36px',
                    height: '36px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    borderRadius: '4px',
                    backgroundColor: '#EFF1F3',
                  }}
                >
                  {group.image_url ? (
                    <img src={group.image_url} alt={group.name} width={'16px'} height={'16px'} />
                  ) : null}
                </div>
                <Typography
                  minWidth={'75px'}
                  maxWidth={'170px'}
                  noWrap
                  color='#242833'
                  fontWeight={400}
                  fontSize={{ xs: 10, lg: 12 }}
                >
                  {group.name}
                </Typography>
              </Box>
            ))}
          </Marquee>
        ) : (
          <Marquee autoFill pauseOnHover style={{ overflow: 'hidden' }}>
            <Skeleton variant='rectangular' width='200px' height={36} sx={{ borderRadius: '4px', mr: 4 }} />
          </Marquee>
        )}
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Link href={sm.catalogue.index.url} passHref>
          <PrimaryButton sx={{ px: 4 }}>Discover Our Categories</PrimaryButton>
        </Link>
      </div>
    </div>
  );
};

export default CategoriesSlider;
